<template>
  <div id="app">
    <div :class="isLandscape ? 'landscape' : 'portrait'">
      <transition key="page" mode="out-in" enter-active-class="animated fadeIn"
                  leave-active-class="animated fadeOut">
        <router-view @start="playBGM" @stop="stopBGM" @mute="muteBGM" @unmute="unmuteBGM" @play-sound="playSound"/>
      </transition>
    </div>
  </div>
</template>

<script>
  import {Howl} from "howler";

  let sound = null;
  let bgm = null;

  export default {
    data() {
      return {
        isLandscape: true
      }
    },
    methods: {
      resize() {
        this.isLandscape = window.innerWidth > (window.innerHeight * 1.778);
      },
      playBGM() {
        if (sound) {
          return;
        }

        const title = new Howl({
          src: ["audio/vrschool_wc_voice_001.mp3"],
          volume: 0.8
        });
        title.play();

        sound = new Howl({
          src: ["audio/vrschool_bgm_01.mp3"],
          loop: true,
          volume: 0.8
        });
        setTimeout(() => {
          bgm = sound.play();
        }, 2000);
      },
      stopBGM() {
        if (sound) {
          sound.pause();
          sound = null;
        }
      },
      muteBGM() {
        sound.fade(1, 0, 1000, bgm);
      },
      unmuteBGM() {
        sound.fade(0, 1, 1000, bgm);
      },
      playSound(soundName, volume) {
        if (volume === undefined) {
          volume = 0.8;
        }

        const audio = new Howl({
          src: [soundName],
          volume: volume
        });
        audio.play();
      }
    },
    mounted() {
      this.resize();
      window.addEventListener("resize", this.resize);
    },
  }
</script>

<style>
  @import "~ress/ress.css";
  @import "~animate.css";

  html {
    overflow-y: hidden;
  }

  #app {
    background-color: #000000;
    min-height: 100vh;
    display: flex;
    align-items: center;
  }

  .landscape {
    margin: 0 auto;
    height: 100vh;
    width: calc(100vh * 1136 / 640);
  }

  .portrait {
    height: calc(100vw * 640 / 1136);
    width: 100%;
  }

  .container {
    height: 100%;
    position: relative;
  }

</style>
